import AppHeader from '../../layout/AppHeader';
import Attendance from '../../xpost/views/umov/attendance/Attendance.vue';
import AttendanceAdd from '../../xpost/views/umov/attendance/AttendanceAdd.vue';
import ReceiveMerchandise from '../../xpost/views/umov/merchandise/ReceiveMerchandise.vue';
import CollectedMerchandise from '../../xpost/views/umov/merchandise/CollectedMerchandise.vue';

const AttendanceRoutes = [
  {
    path: '/cadastro/atendimento',
    name: 'attendance',
    components: {
      header: AppHeader,
      default: Attendance,
    },
  },
  {
    path: '/cadastro/atendimento/adicionar',
    name: 'attendance.add',
    components: {
      header: AppHeader,
      default: AttendanceAdd,
    },
  },
  {
    path: '/cadastro/atendimento/editar/:id',
    name: 'attendance.edit',
    components: {
      header: AppHeader,
      default: AttendanceAdd,
    },
  },
  {
    path: '/servicos/etiqueta/receber',
    name: 'receive.merchandise',
    components: {
      header: AppHeader,
      default: ReceiveMerchandise,
    },
  },
  {
    path: '/servicos/etiqueta/coletar',
    name: 'collect.merchandise',
    components: {
      header: AppHeader,
      default: CollectedMerchandise,
    },
  },
];

export default AttendanceRoutes;
